// extracted by mini-css-extract-plugin
export default {"portal":"PopupModal_portal__qzSQo","background":"PopupModal_background__4RIlN","content":"PopupModal_content__F6ClX","close":"PopupModal_close__IA69N"};